
<div class="modal-dialog confirm-dialog" style="max-width: 630px;">
  <div class="modal-content">
    <div class="modal-header">
      <h4 class="modal-title">Confirm Customer Rejection</h4>
      <button class="close" type="button" (click)="cancel()">&times;</button>
    </div>
    <div class="modal-body">
      <error [error]="error"></error>
      <div class="row">
        <div class="form-group col">
          <label class="required" for="rejectReasons">Are you sure you want to reject customer? You won't be able to continue with this step until TM selects a new BP ID for this customer..</label>
          <textarea class="form-control" id="rejectReasons" [(ngModel)]="rejectReasons" name="rejectReasons" rows="6" placeholder="Please include a note explaining reason for rejection"></textarea>
        </div>
      </div>
    </div>
    <div class="modal-footer">
      <button class="btn btn-outline-secondary" type="button" (click)="cancel()">Cancel</button>
      <button class="btn btn-primary" type="button" (click)="reject()">Reject Customer</button>
    </div>
  </div>
</div>